import React from 'react';
import * as styles from './RateModalForm.module.scss';
import { Dot } from '@components/Timeline';
import DashedLine from '@components/DashedLine';
import classNames from 'classnames';

export function StepGroup({ className, isVisible, children }) {
  return (
    <div
      className={classNames(styles.stepGroup, className, {
        [styles.visible]: isVisible
      })}
    >
      {children}
    </div>
  );
}

export function Step({
  label,
  labelId,
  number,
  className,
  isVisible,
  isComplete,
  canShow = true,
  showLine = true,
  children
}) {
  return (
    <div
      className={classNames(styles.step, className, {
        [styles.visible]: isVisible,
        [styles.canShow]: canShow,
        [styles.complete]: isComplete
      })}
      aria-hidden={!isVisible}
    >
      {number !== undefined && (
        <Dot
          number={number}
          className={styles.dot}
          isMainTimeline={false}
          color={isComplete ? 'teal' : 'gray'}
          showOnMobile
        />
      )}
      {showLine && (
        <div className={styles.lineWrapper}>
          <DashedLine className={styles.line} />
        </div>
      )}
      <div className={styles.stepContent}>
        {label && (
          <h4
            id={labelId}
            className={styles.label}
          >
            {label}
          </h4>
        )}
        {children}
      </div>
    </div>
  );
}
